import { EProductImageType } from '@/typescript/enums/EProductImageType';
import type { TSides } from '@/typescript/interfaces/TSide';
import type { TUploadImgType } from '@/typescript/interfaces/TUploadImgType';

function getProductImageType(currentSide: TSides, uploadImgType: TUploadImgType): EProductImageType {
    if (uploadImgType === 'cutPath') {
        return EProductImageType.CUTTING_AREA_RECTO;
    }
    if (currentSide === 'recto' && uploadImgType === 'helpGrid') {
        return EProductImageType.HELP_GRID_RECTO;
    }
    if (currentSide === 'verso' && uploadImgType === 'helpGrid') {
        return EProductImageType.HELP_GRID_VERSO;
    }
    return EProductImageType.CUTTING_AREA_RECTO;
}

export { getProductImageType };
